import { Component, Input } from '@angular/core';
import { BranchData, BranchVariant } from '../../models/sell.models';

@Component({
  selector: 'pla-plate-x-branch-card',
  templateUrl: './plate-x-branch-card.component.html',
  styleUrls: ['./plate-x-branch-card.component.scss'],
})
export class PlateXBranchCardComponent {
  @Input() variant: BranchVariant = 'charcoal';
  @Input() tag: string = '';
  @Input() when: string = '';
  @Input() title: string = '';
  @Input() body: string = '';
  @Input() feedLabel: string = '';
  @Input() feedMeta: string = 'Illustrative';
  @Input() data!: BranchData;

  get variantClass(): string {
    return this.variant === 'green' ? 'branch-card--green' : 'branch-card--charcoal';
  }

  get isCash(): boolean {
    return this.variant === 'charcoal';
  }
}
